import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, isRef as _isRef, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8114ad8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "mr-10" }
const _hoisted_3 = { class: "companyTree" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_5 = { style: {"flex-grow":"1"} }
const _hoisted_6 = { class: "mb-10" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("上传")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("批量下载")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("选择对账单")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("选择回单")
const _hoisted_12 = { style: {"text-align":"right"} }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("选择对账单")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("选择回单")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("删除")

import { ref, Ref, reactive, onBeforeMount, inject, onMounted, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, exportHandle } from '@/utils/index'
import { getDropBoxHandle } from '@/views/ViewsComponents/financial/bankDropBox'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 获取公司以及相应时间(左)
  'POST/bank_receipt/company_time': fetchCompany,
  // (右)
  'POST/bank_receipt/list': fetchCompanyTime,
  // 创建公司对账单
  'POST/bank_receipt/create': createReceiptApi,
  // 批量删除
  'POST/bank_receipt/delete_in_batch': batchDelApi,
  // 上传
  'POST/bank_receipt/upload_by_id': upload_by_idApi,
  // 根据id查询
  'POST/bank_receipt/query_by_id': query_by_idApi,
  // 删除单个文件
  'POST/bank_receipt/delete_file': delete_fileApi,
  // 下载单个回单或对账单
  'POST/bank_receipt/download_file': download_fileApi,
  // 批量下载
  'POST/bank_receipt/download_in_batch': download_in_batchApi,
  // 简称
  'POST/bank_receipt/account_name_list': account_name_listApi,
} = Api
const tableHeight = window.innerHeight
const viewsLoading: any= inject('viewsLoading')

let dropObj: any = reactive({ "accountNumber": [], "accountName": [], "bankName": [], "company": [], "currency": [] })
let accountNameList = ref([])
onBeforeMount( () => {
  getDropBoxHandle().then((rep: any) => {
    for (const key in rep) {
      dropObj[key] = [...rep[key]]
    }
  })
  
})

// 上传文件下拉回调
const searchAccountName = () => {
  account_name_listApi({
    bankName: upFormObject.bankName,
    companyName:  upFormObject.companyName,
  }, {contentType: 'formData'}).then((rep: any) => {
    accountNameList.value = rep
    upFormObject.abbreviation = ''
  })
}

const searchElement = ref()
const searchFormObject = reactive({
  bankNames: [],
  collectionRange: [],
})

const corporateTree = ref([])
let originalTree = []
const companyTreeEle = ref()
const searchHandle = () => {
  viewsLoading.value = true
  return fetchCompany({
    startTime: searchFormObject.collectionRange? searchFormObject.collectionRange[0] : '',
    endTime: searchFormObject.collectionRange? searchFormObject.collectionRange[1] : '',
  }).then((rep: any) => {
    // 清空右侧表格
    originalTree = rep
    corporateTree.value = rep.reduce((arr: any, company: any) => {
      arr.push({
        label: company.companyName,
        isCompany: true,
        children: company.timeList.map((e: any) => ({label: e, company: company.companyName}))
      })
      return arr
    }, [])
    
    searchAccount()
  }).finally(() => {
    viewsLoading.value = false
    accountData.value = []
  })
}

onMounted(() => {
  searchHandle()
})

const handleCheckChange = ( data: any, {checkedNodes, halfCheckedNodes}: any) => {
  /* let {checkedNodes, halfCheckedNodes}  =data2
  checkedNodes.map((e: any) => (e.isSelect = true))
  halfCheckedNodes.map((e: any) => (e.isSelect = true)) */
  data.isSelect = true;
  viewsLoading.value = true
  searchAccount().finally(() => {
    viewsLoading.value = false
  })
}

// 对账单搜索
let selectRows: any = ref([])
const accountParams = reactive({})
const accountIdentify = ref(false)
const accountData: any = ref([])
const accountDisabled = ref(false);
const accountPage = ref(1);
const accountTotal = ref(100);

const searchAccount = (isLoad = true) => {
  
  let companyTimeList = []
  const companyObj = companyTreeEle.value.getCheckedNodes().reduce((obj: any, item: any) => {
    if(item.isCompany === true) return obj;
    // 添加日期对应的公司
    obj[item.company] ? obj[item.company].push(item.label) : obj[item.company] = [item.label]
    return obj
  }, {})
  

  if(Object.keys(companyObj).length === 0){
    // 默认搜索全部公司
    companyTimeList = originalTree
  } else {
    for(let company in companyObj){
      companyTimeList.push({
        companyName: company,
        timeList: companyObj[company]
      })
    }
  }

  if(isLoad === true){
    // 非下拉加载, 清空
    accountPage.value = 1
    accountData.value = []
  }

  Object.assign(accountParams, companyTimeList)
  accountIdentify.value = true
  return fetchCompanyTime({
    page: accountPage.value, size: 300,
    companyTimeList,
  }).then((rep: any) => {
    // accountData.value = rep.data
    accountData.value.push(...rep.data)
    accountTotal.value = Math.ceil(rep.rowCount / 100)
  }).finally(() => {
    accountIdentify.value = false
  })
}

const accountLoad = () => {
  if (accountDisabled.value || accountIdentify.value === true || accountData.value.length === 0) return;
  accountPage.value ++;
  if (accountPage.value <= accountTotal.value) {
    searchAccount(false)
  }
  // 禁用滚动
  if (accountPage.value === accountTotal.value) {
    accountDisabled.value = true;
  }
}

const bankFilterArr = computed(() => {
  // 返回表格中所有银行数组
  const arr = accountData.value.map((e: {bankName: string}) => e.bankName)
  return Array.from(new Set(arr)).map(e => ({
    text: e,
    value: e
  }))


})

const filterBankHandler = (value: string, row: User) => {
  return row.bankName === value
}


// 上传
const upFileElement: any = ref()
const isShowUpFile = ref<boolean>(false)
const isUpFileLoad = ref<boolean>(false)
const upFormObject: any = reactive({
  companyName: '',
  bankName: '',
  txnDate: '',
  invoiceBillList: [],
  invoiceFiles: '',
  receiptFileList: [],
  receiptFiles: '',
  abbreviation: '',
})
const submitFile = () => {
  upFileElement.value.validate().then((valid: boolean) => {
    if(!valid) return Promise.reject();
    // 表单校验正常
    const form: any = new FormData()
    upFormObject.invoiceBillList.map((file: any) => {
      form.append('invoiceFiles', file.raw)
    })
    upFormObject.receiptFileList.map((file: any) => {
      form.append('receiptFiles', file.raw)
    })

    form.append('companyName', upFormObject.companyName)
    form.append('bankName', upFormObject.bankName)
    form.append('txnDate', upFormObject.txnDate)
    form.append('abbreviation', upFormObject.abbreviation)

    isUpFileLoad.value = true
    return createReceiptApi(form)
  }).then(() => {
    ElMessage.success('上传成功')
  }).then(() => {
    isShowUpFile.value = false
    // 表单重置
    searchHandle()
    
  }).finally(() => {
    isUpFileLoad.value = false
  })
}

// 批量删除
const delHandle = () => {
  if(selectRows.value.length === 0){
    ElMessage.warning('请至少选一条数据')
    return
  }
  ElMessageBox.confirm('请确认是否删除？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    accountIdentify.value = true
    return batchDelApi(selectRows.value.map((e: any) => e.id))
  }).then(() => {
    searchAccount(false)
    searchHandle()
    accountIdentify.value = false
    ElMessage.success('删除成功')
  }).finally(() => {
    accountIdentify.value = false
  })
}


const btnLoading = ref<boolean>(false)
// 管理对账单
const isShowAccount = ref(false)
let accountFiles = ref([])
let accountFileList = ref([])
const accountFileRow: any = reactive({})
const upAccountHandle = (file: any) => {
  
  const form: any = new FormData()
  form.append('invoiceFiles', file.file)
  /* accountFiles.value.map((file: any) => {
    form.append('invoiceFiles', file.raw)
  }) */
  form.append('id', accountFileRow.id)
  btnLoading.value = true
  upload_by_idApi(form).then(() => {
    ElMessage.success('上传成功')
    accountFiles.value = []
    return query_by_idApi({id: accountFileRow.id}, {contentType: 'formData'})
  }).then(({invoiceFileList: list}: any) => {
    accountFileList.value = list
    // searchAccount()
  }).finally(() => {
    btnLoading.value = false
  })
}

// 回单
const isShowReceipt = ref(false)
let receiptFiles = ref([])
let receiptFileList = ref([])
const receiptFileRow: any = reactive({})
const upReceiptHandle = (file: any) => {
  const form: any = new FormData()
  form.append('receiptFiles', file.file)
  form.append('id', receiptFileRow.id)
  btnLoading.value = true
  upload_by_idApi(form).then(() => {
    ElMessage.success('上传成功')
    receiptFiles.value = []
    return query_by_idApi({id: receiptFileRow.id}, {contentType: 'formData'})
  }).then(({receiptFileList: list}: any) => {
    receiptFileList.value = list
    // searchAccount()
  }).finally(() => {
    btnLoading.value = false
  })
}


// 删除
const delSingleHandle = (row: any, id: string) => {
  // delete_fileApi({fileId: row.fileId}, {contentType: 'formData'})
  ElMessageBox.confirm('请确认是否删除？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    btnLoading.value = true
    return delete_fileApi({fileId: row.fileId}, {contentType: 'formData'})
  }).then(() => {
    ElMessage.success('删除成功')
    btnLoading.value = false
    return query_by_idApi({id: id}, {contentType: 'formData'})
  }).then(({invoiceFileList: invoiceList, receiptFileList: receiptList, }: any) => {
    accountFileList.value = invoiceList
    receiptFileList.value = receiptList
  }).finally(() => {
    btnLoading.value = false
  })

}

// 单个下载
const donwalSingleHandle = (row: any) => {
  ElMessageBox.confirm('请确认是否下载？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    btnLoading.value = true
    return exportHandle(download_fileApi, {fileId: row.fileId}, {contentType: 'formData'})
  }).finally(() => {
    btnLoading.value = false
  })
}
// 批量下载
const batchDownloadHandle = (() => {
  if(selectRows.value.length === 0){
    ElMessage.warning('请至少选一条数据')
    return
  }
  ElMessageBox.confirm('请确认是否下载？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    accountIdentify.value = true
    return exportHandle(download_in_batchApi, selectRows.value.map((e: any) => e.id))
  }).finally(() => {
    accountIdentify.value = false
  })
})


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_space = _resolveComponent("el-space")!
  const _directive_el_table_infinite_scroll = _resolveDirective("el-table-infinite-scroll")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_date_picker, {
          class: "mb-10",
          modelValue: _unref(searchFormObject).collectionRange,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchFormObject).collectionRange) = $event)),
          type: "monthrange",
          "value-format": "YYYY-MM-DD",
          "range-separator": "至",
          "start-placeholder": "开始时间",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (searchHandle())),
          "end-placeholder": "结束时间",
          placeholder: "请选择交易日期"
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_tree, {
            onCheck: handleCheckChange,
            ref_key: "companyTreeEle",
            ref: companyTreeEle,
            data: corporateTree.value,
            props: { children: 'children', label: 'label' },
            "show-checkbox": ""
          }, null, 8, ["data"])
        ]),
        _createVNode(_component_el_button, {
          class: "mb-10 mt-10",
          style: {"width":"100%"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (searchAccount()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (isShowUpFile.value = true)),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            disabled: _unref(selectRows).length === 0,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (batchDownloadHandle()))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            disabled: _unref(selectRows).length === 0,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (delHandle())),
            type: "danger"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          "infinite-scroll-disabled": accountDisabled.value,
          onSelectionChange: _cache[6] || (_cache[6] = (rows) => _isRef(selectRows) //@ts-ignore
 ? selectRows.value = rows : selectRows = rows),
          border: "",
          data: accountData.value,
          height: _unref(tableHeight) - 280
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "selection",
              width: "50"
            }),
            _createVNode(_component_el_table_column, {
              label: "银行名称",
              prop: "bankName",
              "show-overflow-tooltip": "",
              filters: _unref(bankFilterArr),
              "filter-method": filterBankHandler
            }, null, 8, ["filters"]),
            _createVNode(_component_el_table_column, {
              label: "账户简称",
              prop: "abbreviation",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "日期",
              prop: "txnDate",
              "show-overflow-tooltip": "",
              sortable: ""
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(row.txnDate).format('YYYY-MM')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "公司名称",
              prop: "companyName",
              sortable: "",
              width: "260"
            }),
            _createVNode(_component_el_table_column, {
              label: "对账单",
              prop: "",
              width: "110"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (Object.assign(_unref(accountFileRow), row), _isRef(accountFileList) //@ts-ignore
 ? accountFileList.value = row.invoiceFileList : accountFileList = row.invoiceFileList, isShowAccount.value = true)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("(" + _toDisplayString(row.invoiceFileList.length) + ")下载/上传", 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "回单",
              prop: "",
              width: "110"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (Object.assign(_unref(receiptFileRow), row), _isRef(receiptFileList) //@ts-ignore
 ? receiptFileList.value = row.receiptFileList : receiptFileList = row.receiptFileList, isShowReceipt.value = true)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("(" + _toDisplayString(row.receiptFileList.length) + ")下载/上传", 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "创建人",
              prop: "alias",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              label: "创建时间",
              prop: "createdAt",
              sortable: "",
              width: "160"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", null, _toDisplayString(_unref(dayjs)(row.createdAt).format('YYYY-MM-DD HH:mm')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["infinite-scroll-disabled", "data", "height"])), [
          [_directive_el_table_infinite_scroll, accountLoad],
          [_directive_loading, accountIdentify.value]
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "上传文件",
      center: "",
      modelValue: isShowUpFile.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((isShowUpFile).value = $event)),
      "show-close": false,
      width: "800px",
      onClose: _cache[16] || (_cache[16] = ($event: any) => (upFileElement.value.resetFields()))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (isShowUpFile.value = false)),
            disabled: isUpFileLoad.value
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (submitFile())),
            loading: isUpFileLoad.value
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-position": "left",
          model: _unref(upFormObject),
          class: "mb-10",
          disabled: isUpFileLoad.value,
          inline: true,
          ref_key: "upFileElement",
          ref: upFileElement,
          "label-width": "100"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "公司名称:",
              prop: "companyName",
              rules: { required: true, message: '请选择公司名称', trigger: 'change'}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  onChange: searchAccountName,
                  class: "form-input",
                  filterable: "",
                  modelValue: _unref(upFormObject).companyName,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(upFormObject).companyName) = $event)),
                  placeholder: "请选择公司名称",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).company, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        key: item.id,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "银行名称:",
              prop: "bankName",
              rules: { required: true, message: '请选择银行名称', trigger: 'change'}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "form-input",
                  onChange: searchAccountName,
                  filterable: "",
                  modelValue: _unref(upFormObject).bankName,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(upFormObject).bankName) = $event)),
                  placeholder: "请选择银行名称",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dropObj).bankName, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        key: item.id,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "日期:",
              prop: "txnDate",
              rules: { required: true, message: '请选择日期', trigger: 'change'}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _unref(upFormObject).txnDate,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(upFormObject).txnDate) = $event)),
                  type: "month",
                  "value-format": "YYYY-MM",
                  "range-separator": "至",
                  "start-placeholder": "开始时间",
                  "end-placeholder": "结束时间",
                  placeholder: "请选择交易日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "账户简称",
              prop: "abbreviation"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "form-input",
                  filterable: "",
                  modelValue: _unref(upFormObject).abbreviation,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(upFormObject).abbreviation) = $event)),
                  placeholder: "请选择账户简称",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accountNameList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item,
                        key: item,
                        value: item
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_form_item, {
              label: "",
              prop: "invoiceBillList"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  "file-list": _unref(upFormObject).invoiceBillList,
                  "onUpdate:file-list": _cache[11] || (_cache[11] = ($event: any) => ((_unref(upFormObject).invoiceBillList) = $event)),
                  ref: "upload",
                  style: {"width":"675px"},
                  "auto-upload": false
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: "UploadFilled",
                      plain: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_form_item, {
              label: "",
              prop: "receiptFileList"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  "file-list": _unref(upFormObject).receiptFileList,
                  "onUpdate:file-list": _cache[12] || (_cache[12] = ($event: any) => ((_unref(upFormObject).receiptFileList) = $event)),
                  ref: "upload",
                  style: {"width":"675px"},
                  "auto-upload": false
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: "UploadFilled",
                      plain: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      center: "",
      title: "管理对账单",
      modelValue: isShowAccount.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isShowAccount).value = $event)),
      onClose: _cache[19] || (_cache[19] = ($event: any) => (searchAccount()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          "file-list": _unref(accountFiles),
          "onUpdate:file-list": _cache[17] || (_cache[17] = ($event: any) => (_isRef(accountFiles) ? (accountFiles).value = $event : accountFiles = $event)),
          multiple: "",
          ref: "upload",
          "auto-upload": true,
          "http-request": upAccountHandle
        }, {
          trigger: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "UploadFilled",
              plain: ""
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["file-list"]),
        _createVNode(_component_el_divider),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _unref(accountFileList),
          "max-height": "500px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              type: "index",
              width: "70"
            }),
            _createVNode(_component_el_table_column, {
              label: "文件名",
              prop: "filename"
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (donwalSingleHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      type: "danger",
                      onClick: ($event: any) => (delSingleHandle(row, _unref(accountFileRow).id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, btnLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      center: "",
      title: "管理回单",
      modelValue: isShowReceipt.value,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((isShowReceipt).value = $event)),
      onClose: _cache[22] || (_cache[22] = ($event: any) => (searchAccount()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          "file-list": _unref(receiptFiles),
          "onUpdate:file-list": _cache[20] || (_cache[20] = ($event: any) => (_isRef(receiptFiles) ? (receiptFiles).value = $event : receiptFiles = $event)),
          multiple: "",
          ref: "upload",
          "auto-upload": true,
          "http-request": upReceiptHandle
        }, {
          trigger: _withCtx(() => [
            _createVNode(_component_el_button, {
              icon: "UploadFilled",
              plain: ""
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["file-list"]),
        _createVNode(_component_el_divider),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _unref(receiptFileList),
          "max-height": "500px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              type: "index",
              width: "70"
            }),
            _createVNode(_component_el_table_column, {
              label: "文件名",
              prop: "filename"
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: ($event: any) => (donwalSingleHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_link, {
                      type: "danger",
                      onClick: ($event: any) => (delSingleHandle(row, _unref(receiptFileRow).id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, btnLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})